import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ListCellDefDirective,
  ListModuleColumnDef,
  ListModuleTableComponent,
} from 'src/app/shared/components/list-module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import type { AuditLogRow } from 'src/app/core/services/audit-log-api.service';
import { parseUserAgent } from './audit-diff.util';
import {
  actionLabel,
  actionVerbTone,
  outcomeChipClass,
  resourceLabel,
  TONE_CHIP_CLASS,
} from './audit-action-label.util';

/** Renders audit rows on the shared list table; the page owns data, filters and the drawer. */
@Component({
  selector: 'app-audit-log-table',
  standalone: true,
  imports: [CommonModule, IconModule, ListModuleTableComponent, ListCellDefDirective],
  templateUrl: './audit-log-table.component.html',
})
export class AuditLogTableComponent {
  @Input() rows: AuditLogRow[] = [];
  @Input() loading = false;
  @Input() emptyMessage =
    'No changes recorded for these filters. Every create, edit and delete lands here automatically.';
  /** Hide the resource column when the table is embedded on a single record's page. */
  @Input() showResource = true;

  @Output() view = new EventEmitter<AuditLogRow>();

  get columns(): ListModuleColumnDef[] {
    return [
      { id: 'date', header: 'When', cellClass: 'whitespace-nowrap' },
      { id: 'action', header: 'Action', cellClass: 'min-w-[12rem]' },
      { id: 'resource', header: 'Record', cellClass: 'whitespace-nowrap text-sm', visible: this.showResource },
      { id: 'actor', header: 'By', cellClass: 'min-w-[10rem] max-w-[16rem] truncate text-sm' },
      { id: 'origin', header: 'From', cellClass: 'whitespace-nowrap text-xs text-gray-500' },
      { id: 'outcome', header: 'Result', align: 'center', cellClass: 'whitespace-nowrap text-center' },
      { id: 'actions', header: '', align: 'right', cellClass: 'text-end' },
    ];
  }

  label(row: AuditLogRow): string {
    return actionLabel(row.action);
  }
  chipClass(row: AuditLogRow): string {
    return TONE_CHIP_CLASS[actionVerbTone(row.action)];
  }
  outcomeClass(row: AuditLogRow): string {
    return outcomeChipClass(row.outcome);
  }
  record(row: AuditLogRow): string {
    return resourceLabel(row.resource_type, row.resource_id);
  }
  actor(row: AuditLogRow): string {
    if (row.actor_email) return row.actor_email;
    return row.actor_id ? `#${row.actor_id}` : 'System';
  }
  client(row: AuditLogRow): string {
    const ua = parseUserAgent(row.user_agent);
    return ua.browser === '—' ? '' : `${ua.browser} on ${ua.platform}`;
  }
}
